import SideNavigation from "../Common/sideNavigation";

import { useHistory } from "react-router-dom";
import { useRef, useState, Fragment, useEffect } from 'react';

import VerifiedUser from "./verifiedUser";
import ApprovalModal from './Modals/approvalModal';
import UserRequestsTable from "./UserRequests/userRequestsTable";
import ResponseNotification from './Modals/responseNotification';

/**
 * Returns the User Management page component.
 * 
 * @returns The User Management page component.
 */
const UserManagement = () => {
  let history = useHistory();

  const [selectedUser, setSelectedUser] = useState([]);

  const cancelButtonRef = useRef(null);
  const [isApprove, setIsApprove] = useState(null);
  const [approvalOpen, setApprovalOpen] = useState(false);
  const [notificationShow, setNotificationShow] = useState(false);
  const [notificationPurpose, setNotificationPurpose] = useState("");
  const [notification, setNotification] = useState({
    status: false,
    title: "",
    message: "",
  });

  useEffect(() => {
    // Delete state when page reloads - state will continue to exist when refresh so code is needed
    window.history.replaceState({}, document.title);

    updateUserNotification();
  }, []);

  /**
   * Retrieves the response message from the request to update/change user information.
   */
  const updateUserNotification = () => {
    if (typeof history.location.state !== "undefined") {
      const state = history?.location?.state;

      setNotification({
        status: state.status,
        title: state.title,
        message: state.message,
      });

      setNotificationShow(true);
      setNotificationPurpose("User");
    }
  };

  /**
   * Handles the selected user.
   * 
   * @param {User} user 
   */
  const SelectedUserHandler = (user) => {
    setNotificationShow(false);
    setApprovalOpen(true);
    setSelectedUser(user);
  };

  return (
    <>
      <div className="flex flex-col h-fit md:h-screen">
        <div className="h-full bg-gray-50">
          <SideNavigation />

          <main className="lg:pl-72 bg-gray-50 h-full">
            <div className="">
              <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-6">



                {/* File Acceleration Modal */}
                <ApprovalModal
                  as={Fragment}
                  show={approvalOpen}
                  onClose={setApprovalOpen}
                  setOpen={setApprovalOpen}
                  setIsApprove={setIsApprove}
                  selectedUser={selectedUser}
                  setShow={setNotificationShow}
                  initialFocus={cancelButtonRef}
                  cancelButtonRef={cancelButtonRef}
                  setNotificationPurpose={setNotificationPurpose}
                />

                <div className="">
                  {/* Response Modal of the requests from EDITING to APPROVING/REJECTING File acceleration of a user */}
                  <ResponseNotification
                    as={Fragment}
                    isApprove={isApprove}
                    show={notificationShow}
                    selectedUser={selectedUser}
                    notification={notification}
                    setShow={setNotificationShow}
                    notificationPurpose={notificationPurpose}
                  />

                  <div className="grid grid-cols-3 space-x-0 2xl:space-x-4 space-y-4 2xl:space-y-0">
                    <div className="col-span-3 2xl:col-span-1 py-6 px-6 md:py-12 bg-white border border-gray-200 rounded-lg shadow-sm">
                      <header className="md:w-full">
                        <h1 className="text-2xl py-2 font-bold leading-tight text-gray-900">
                          Contributor Access Requests
                        </h1>
                      </header>

                      <main className="mt-2 overflow-hidden">
                        {/* Side by side table in desktop and top/bottom table view mobile */}
                        <div className="">
                          <UserRequestsTable />
                        </div>
                      </main>
                    </div>

                    <div className="col-span-3 2xl:col-span-2 py-6 md:px-5 md:py-12 bg-white border border-gray-200 rounded-lg xl:p-12 shadow-sm">
                      <header className="md:w-full">
                        <h1 className="text-2xl py-2 font-bold leading-tight text-gray-900">
                          Users
                        </h1>
                      </header>

                      <main className="mt-2 overflow-hidden">
                        {/* Side by side table in desktop and top/bottom table view mobile */}
                        <div className="flex flex-col space-y-10 space-x-0 lg:flex-row lg:space-y-0 lg:space-x-10">
                          <VerifiedUser
                            setShow={setNotificationShow}
                            selectedUserHandler={SelectedUserHandler}
                          />
                        </div>
                      </main>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default UserManagement;